import { render, staticRenderFns } from "./ConfigValue.vue?vue&type=template&id=a85398f2&scoped=true&"
import script from "./ConfigValue.vue?vue&type=script&lang=js&"
export * from "./ConfigValue.vue?vue&type=script&lang=js&"
import style0 from "./ConfigValue.vue?vue&type=style&index=0&id=a85398f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85398f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a85398f2')) {
      api.createRecord('a85398f2', component.options)
    } else {
      api.reload('a85398f2', component.options)
    }
    module.hot.accept("./ConfigValue.vue?vue&type=template&id=a85398f2&scoped=true&", function () {
      api.rerender('a85398f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/configurationManager/ConfigValue.vue"
export default component.exports